import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	auth: {
		login: null
	}
});
